var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20311 -1816)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20311 1816)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17373.793 -1565.809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2927.168,3399.839q0-4.253,0-8.505a1.994,1.994,0,0,1,2.119-2.141c2.231-.007,4.462,0,6.694-.008.333,0,.451.087.447.437-.018,1.565-.012,3.131,0,4.7,0,.832.286,1.28.958,1.477a3.043,3.043,0,0,0,.841.082c1.5.007,3.008.01,4.512,0,.276,0,.357.067.356.346-.009,4.031,0,8.062-.009,12.093a1.946,1.946,0,0,1-2.153,2.12q-5.843,0-11.686,0a1.948,1.948,0,0,1-2.073-2.087Q-2927.171,3404.092-2927.168,3399.839Zm2.9,2c.065.374.11.752.2,1.121a4.289,4.289,0,0,0,6.114,2.751.427.427,0,0,1,.6.107c.6.6,1.186,1.219,1.823,1.779a.933.933,0,0,0,1.531-.346,1.012,1.012,0,0,0-.259-1.21c-.531-.549-1.058-1.1-1.606-1.633a.5.5,0,0,1-.128-.692,4.157,4.157,0,0,0-.476-4.617,4.189,4.189,0,0,0-4.36-1.522A4.316,4.316,0,0,0-2924.269,3401.836Z",
    transform: "translate(0)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2778.159,3395.746h-3.028c-.567,0-1.134,0-1.7,0-.18,0-.309-.019-.308-.252.005-1.614,0-3.227,0-4.841l.131-.107,5.028,5.03Z",
    transform: "translate(-133.32 -1.262)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2855.161,3531.421a2.21,2.21,0,0,0-2.29-2.277,2.25,2.25,0,0,0-2.293,2.3,2.262,2.262,0,0,0,2.311,2.282A2.217,2.217,0,0,0-2855.161,3531.421Z",
    transform: "translate(-62.436 -129.605)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2855.161,3531.421a2.217,2.217,0,0,1-2.271,2.3,2.262,2.262,0,0,1-2.311-2.282,2.25,2.25,0,0,1,2.293-2.3A2.21,2.21,0,0,1-2855.161,3531.421Z",
    transform: "translate(-62.436 -129.605)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon-information.532c08a4.svg";
export { ForwardRef as ReactComponent };